/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import MenuHistoryOrder from "./Components/MenuHistoryOrder";

import {
	getListHistoryOrderAction,
	setMenuChildrenHistoryAction,
	setMenuParentHistoryAction
} from "store/actions/OrderPageAction";
import { connect } from "react-redux";
import { formatDate } from "config/constant";
import { checkMobile } from "config/constant";

export const TYPE_ORDER = [
	{
		label: "Đơn mua",
		type: "CRM"
	},
	{
		label: "Từ NVBH",
		type: "SALEMAN_APP"
	}
];

const OrderHistoryPage = props => {
	const {
		getListHistoryOrder,
		listHistoryOrder,
		menuChildren,
		menuParent,
		setMenuChildrenHistory,
		setMenuParentHistory,
		infoShop
	} = props;
	const [isMobile, setMobile] = useState(false);
	const [type, setType] = useState(menuParent);
	const business = infoShop?.business || "THOPHAT";

	useEffect(() => {
		setMobile(checkMobile());
		fetchListOrder(TYPE_ORDER[menuChildren]?.type, menuParent);
	}, []);

	//set 3 tháng gần nhất
	const fetchListOrder = (orderSource, type) => {
		const currentDate = new Date();
		const toDate = formatDate(currentDate);
		currentDate.setMonth(currentDate.getMonth() - 3);
		const fromDate = formatDate(currentDate);

		const data = {
			fromDate: fromDate,
			toDate: toDate,
			orderSource: type === "SALE" ? orderSource : null,
			type: type
		};
		getListHistoryOrder(data);
	};

	const handleMenuSelected = typeMenuParent => {
		setType(typeMenuParent);
		setMenuParentHistory(typeMenuParent);
		fetchListOrder(TYPE_ORDER[menuChildren]?.type, typeMenuParent);
	};

	return (
		<MenuHistoryOrder
			listOrder={listHistoryOrder?.orders}
			isMobile={isMobile}
			fetchListOrder={fetchListOrder}
			handleMenuSelected={handleMenuSelected}
			orderType={type}
			menuChildren={menuChildren}
			setMenuChildrenHistory={setMenuChildrenHistory}
			business={business}
		/>
	);
};

const mapStateToProps = state => {
	return {
		listHistoryOrder: state.orderPageReducer.listHistoryOrder,
		menuChildren: state.orderPageReducer.menuChildren,
		menuParent: state.orderPageReducer.menuParent,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getListHistoryOrder: data => {
			dispatch(getListHistoryOrderAction(data));
		},
		setMenuChildrenHistory: data => {
			dispatch(setMenuChildrenHistoryAction(data));
		},
		setMenuParentHistory: data => {
			dispatch(setMenuParentHistoryAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistoryPage);
